export default "__VITE_ASSET__B0h81bbk__"